module.exports = __webpack_public_path__ + "img/yocketHydrogen.9909ef5.svg";